export default () => [
    'Complete Form',
    'Confirm Code',
    'Login',
  ];
  